<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        class="pb-0"
      >
        <v-autocomplete
          v-model="socsoContributionCategory"
          v-validate="isEmployeeSocsoContribute?'required':''"
          :error-messages="errors.collect('socsoContributionCategory')"
          :items="socsoContributionCategories"
          data-vv-name="socsoContributionCategory"
          data-vv-as="SOCSO contribution category"
          item-text="name"
          item-value="key"
          label="SOCSO Contribution Category"
          outlined
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <span class="font-weight-bold">{{ data.item.name }}</span>
              <span style="width:100px">{{ data.item.description }}</span>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDateDisplay"
              v-validate="'required'"
              :error-messages="errors.collect('startDateDisplay')"
              data-vv-name="startDateDisplay"
              data-vv-as="start date"
              label="Start date"
              outlined
              readonly
              class="label-position"
              v-on="on"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            type="month"
            :min="$moment().subtract(1, 'months').format('YYYY-MM')"
            :value="startDateDisplay"
            no-title
            @input="startDateMenu = false"
          />
        </v-menu>
      </v-col>
    </v-row>

    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="progressing"
        class="px-10"
        text
        @click="closeDialog"
      >
        Close
      </v-btn>
      <v-btn
        :loading="progressing"
        color="hrissecondary"    
        class="white--text px-10"       
        @click="submitForm"
      >
        submit
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployeeUid: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        startDateMenu: false,
        startDate: null,
        isEmployeeSocsoContribute: 1,
        isEmployerSocsoContribute: 1,
        socsoContributionCategories: [
          { key: 0, name: 'No Contribution', description: 'No contribution for both employee and employer.' },
          { key: 1, name: 'First Category', description: 'All employees who have not reached the age of 60, must contribute under the First Category except for those who have attained 55 years of age and have no prior contributions before they reach 55 due to non-eligibility under the Employees’ Social Security Act, 1969' },
          { key: 2, name: 'Second Category', description: 'All employees who have reached the age of 60 must be covered under this category for the Employment Injury Scheme only.' },
        ],
        socsoContributionCategory: null,
        progressing: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
    },
    methods: {
      submitForm () {
        this.$validator.resume()

        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.companyEmployeeSocsoContributions().create(this.companyEmployeeUid, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })

                this.$validator.pause()
                this.setProgressing(false)
              })
              .catch((err) => {
                if (err.response.status === 422) {    
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.setProgressing(false)
              })
          })
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
      prepareFormData () {
        if (this.socsoContributionCategory === 0) {
          this.isEmployeeSocsoContribute = 0
          this.isEmployerSocsoContribute = 0
        } else {
          this.isEmployeeSocsoContribute = 1
          this.isEmployerSocsoContribute = 1
        }
        return {
          start_date: this.startDate + '-01',
          is_employee_contributed: this.isEmployeeSocsoContribute,
          is_employer_contributed: this.isEmployerSocsoContribute,
          contribution_category: this.socsoContributionCategory,
        }
      },
      setProgressing (status) {
        this.progressing = status
      },
      clearData () {
        this.contribution_category = null
        this.startDateMenu = false
        this.startDate = null
        this.isEmployerSocsoContribute = 1
        this.isEmployeeSocsoContribute = 1
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:4px
}
</style>
